/**
 * Fulfillment module permission keys.
 * Keep in sync with backend role definitions.
 */
export const FULFILLMENT_PERMISSIONS = {
  ORDER_READ: "fulfillment:order:read",
  ORDER_DETAILS_READ: "fulfillment:order:details-read",
  ORDER_SEARCH: "fulfillment:order:search",
  ORDER_ASSIGN_PICKER: "fulfillment:order:assign-picker",
  ORDER_ASSIGN_REGISTER: "fulfillment:order:assign-register",
  PICKER_READ: "fulfillment:picker:read",
  PICKER_PICK: "fulfillment:picker:pick",
  DISPATCH_READ: "fulfillment:dispatch:read",
  DISPATCH_READY: "fulfillment:dispatch:ready",
  DISPATCH_DISPATCH: "fulfillment:dispatch:dispatch",
  DISPATCH_REJECT: "fulfillment:dispatch:reject"
} as const

export type FulfillmentPermission =
  (typeof FULFILLMENT_PERMISSIONS)[keyof typeof FULFILLMENT_PERMISSIONS]
